import { Box, Flex, Link as ChakraLink } from "@chakra-ui/react";

import { DashboardInput } from "../../components/dashboard-input/DashboardInput";
import { DashboardButton } from "../../components/dashboard-button/DashboardButton";

import { NextButton } from "../../components/next-button/NextButton";
import { ChangeEvent, useState } from "react";
import { ClientTable } from "./ClientTable";

export const Clients = () => {
  const [term, setTerm] = useState<string | undefined>();

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setTerm(e.target.value);
  };

  return (
    <Box position="relative" height="100%" padding="64px 84px 16px 84px">
      <Flex justifyContent="space-between">
        <Box>
          <DashboardInput
            borderRadius="24px"
            onChange={handleInputChange}
            name="term"
            placeholder="Pesquisar..."
            type="search"
            icon="lupa.png"
            value={term}
          />
        </Box>
        <Box>
          <ChakraLink
            textDecoration="none"
            _hover={{
              textDecoration: "none",
            }}
            href="/clientes/cadastro"
          >
            <DashboardButton borderRadius="32px" icon="plus.png">
              Novo Cliente
            </DashboardButton>
          </ChakraLink>
        </Box>
      </Flex>
      <Box>
        <ClientTable term={term} />
      </Box>
      <NextButton marginRight="16px" marginBottom="16px">
        Avançar
      </NextButton>
    </Box>
  );
};
